"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutomationsTelemetry = void 0;
var inversify_react_1 = require("inversify-react");
var AutomationsApiService_1 = require("Library/AutomationLibrary/AutomationsApiService");
var react_1 = require("react");
var useAutomationsTelemetry = function (integrationName) {
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var data = (0, AutomationsApiService_1.useAutomations)({ integrationName: integrationName }).data;
    var automationCount = data ? data.length : 0;
    return (0, react_1.useMemo)(function () {
        var trackAssignmentSkipped = function (reminderDismissed) { return __awaiter(void 0, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, serverTelemetry.sendAutomationsTelemetry("Automation Assignment Reminder Shown", {
                                reminderDismissed: reminderDismissed,
                            })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error("Failed to send telemetry to the server", e_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var trackLibraryViewed = function (activeTab) { return __awaiter(void 0, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, serverTelemetry.sendAutomationsTelemetry("Automation Library Viewed", {
                                automationCount: automationCount,
                                activeTab: activeTab,
                            })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.error("Failed to send telemetry to the server", e_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var trackHubspotReEnableModalShown = function () { return __awaiter(void 0, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, serverTelemetry.sendAutomationsTelemetry("HubSpot Re-enable Modal Shown")];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_3 = _a.sent();
                        console.error("Failed to send telemetry to the server", e_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var trackAutomationClicked = function (automationId) { return __awaiter(void 0, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, serverTelemetry.sendAutomationsTelemetry("Automation Clicked", {
                                automationId: automationId,
                            })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_4 = _a.sent();
                        console.error("Failed to send telemetry to the server", e_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var trackRecommendedAutomationClicked = function (automationDescription) { return __awaiter(void 0, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, serverTelemetry.sendAutomationsTelemetry("Recommended Automation Clicked", {
                                automationDescription: automationDescription,
                            })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_5 = _a.sent();
                        console.error("Failed to send telemetry to the server", e_5);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var trackAutomationCreateClicked = function (params) { return __awaiter(void 0, void 0, void 0, function () {
            var e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, serverTelemetry.sendAutomationsTelemetry("Automation Create Button Clicked", params)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_6 = _a.sent();
                        console.error("Failed to send telemetry to the server", e_6);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        var trackAutomationEnabledToggled = function (automationId, enabled) { return __awaiter(void 0, void 0, void 0, function () {
            var e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, serverTelemetry.sendAutomationsTelemetry("Automation Enable Toggled", {
                                automationId: automationId,
                                enabled: enabled,
                            })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_7 = _a.sent();
                        console.error("Failed to send telemetry to the server", e_7);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        return {
            trackLibraryViewed: trackLibraryViewed,
            trackHubspotReEnableModalShown: trackHubspotReEnableModalShown,
            trackAutomationClicked: trackAutomationClicked,
            trackRecommendedAutomationClicked: trackRecommendedAutomationClicked,
            trackAutomationCreateClicked: trackAutomationCreateClicked,
            trackAutomationEnabledToggled: trackAutomationEnabledToggled,
            trackAssignmentSkipped: trackAssignmentSkipped,
        };
    }, [automationCount, serverTelemetry]);
};
exports.useAutomationsTelemetry = useAutomationsTelemetry;
